import { BarChart3, Boxes, TrendingUp } from 'lucide-react';

import { Brand, LanguageSwitcher, ThemeSwitcher } from '../../../components';
import { useI18n } from '../../../i18n';

export const AuthLayout = ({ children }) => {
  const { t } = useI18n();

  return (
    <div className='wm-auth'>
      <div className='wm-auth__panel'>
        <div className='wm-auth__top'>
          <Brand />
          <div style={{ display: 'flex', gap: 6 }}>
            <LanguageSwitcher compact />
            <ThemeSwitcher />
          </div>
        </div>
        <div className='wm-auth__form-wrap'>
          <div className='wm-auth__form'>{children}</div>
        </div>
      </div>
      <aside className='wm-auth__aside'>
        <h2>{t('login.asideTitle')}</h2>
        <p>{t('login.asideText')}</p>
        <ul>
          <li>
            <TrendingUp />
            {t('login.feature1')}
          </li>
          <li>
            <Boxes />
            {t('login.feature2')}
          </li>
          <li>
            <BarChart3 />
            {t('login.feature3')}
          </li>
        </ul>
      </aside>
    </div>
  );
};
